import { 
  Avatar, 
  Box, 
  Show, 
  Stack, 
  Text, 
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon
} from "@chakra-ui/react";
import { UilAngleDown } from "@iconscout/react-unicons";
import { ReactComponent as LogoutIcon } from "app/assets/svg/logout.svg";
import { useAppSelector } from "app/hooks";
import { useLogoutFunction } from "app/hooks";

const HeaderAvatar = () => {
  const auth = useAppSelector((state) => state.dashboard.userProfile);
  const logout = useLogoutFunction();
  
  return (
    <Menu>
      <MenuButton>
        <Stack
          spacing={[0, 3]}
          direction="row"
          alignItems="center"
          cursor="pointer"
        >
          <Avatar
            width={10}
            height={10}
            borderRadius={16}
            src="https://bit.ly/kent-c-dodds"
          />
          <Show breakpoint="(min-width: 500px)">
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Text
                fontSize={16}
                color="#04060C"
                fontWeight={500}
                lineHeight="19px"
                className="truncate"
                textAlign="left"
              >
                {auth.firstName} {auth.lastName}
              </Text>
              <Text
                fontSize={14}
                color="gray.600"
                lineHeight="18px"
                className="truncate"
                textAlign="left"
              >
                {auth.email}
              </Text>
            </Box>
          </Show>
          <UilAngleDown />
        </Stack>
      </MenuButton>
      <MenuList>
        <MenuItem
          onClick={logout}
          color="#DB2438"
          _hover={{ bg: "red.50" }}
          gap={3}
        >
          <Icon as={LogoutIcon} width={5} height={5} />
          Logout
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default HeaderAvatar;
